/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p1.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p2.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p3.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p4.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p5.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-p6.png",

    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b1.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b2.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b3.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b4.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b5.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-b6.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c1.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c2.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c3.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c4.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c5.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-c6.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-size-img1.png",
    "https://cdn.shopify.com/s/files/1/0643/2718/8649/files/20251013-size-img2.png",
  ];
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
  });
  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    speed: 5000,
    loop: true,
    spaceBetween: 24,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom") +
            10,
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 22.99;
  let sp_price2 = 59.99;

  let sp_price_list = [
    {
      price1: 22.99,
      price2: 59.99,
    },
    {
      price1: 22.99,
      price2: 59.99,
    },
  ];

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  let prods = window.product
    function getCur(){
      let color = $('#sp-color div.active').attr('data-val')
      let size = $('#sp-size div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    //   price = (price + '').replace('.', ',')
    //   compare = (compare + '').replace('.', ',')
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".product-part .sp-row p span").html(off_font);
    }
    $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  $(".option").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    // $(this);
    // style选项

    let colorOptions = $("#sp-color .option.active").index();

    let img0 = $(".product-part .sp-index1 .p-img");

    img0[0].srcset = spImgList[colorOptions];
    changePrice()
  });

  // 弹窗内尺码表切换
  $(".sp-size-part2 .btn-wrap").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    let index = $(this).index();
    $(".sp-size-part2 .sp-size1").eq(index).show().siblings(".sp-size1").hide();
  });

  // 展示尺码弹窗
  $(".sp-size-btn").click(function () {
    $(".sp-mask").css("display", "flex");
    $(".sp-mask .size-pop").show();
    $(".sp-mask .img-pop").hide();
  });
  // 关闭弹窗按钮

  $(".sp-mask").click(function (e) {
    if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
    } else {
      $(".sp-mask").hide();
    }
  });

  // 尺码表切换事件
  $(".sp-size-wrap2 .sp-btn").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    let index = $(this).index();
    $(this)
      .parents(".sp-size-wrap2")
      .find(".sp-size-img")
      .eq(index)
      .show()
      .siblings(".sp-size-img")
      .hide();
  });

  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    // 双购物部分处理

    let spShopIndex = 0;
    // $(".sp-check").click(function () {
    //   $(this).addClass("active").siblings().removeClass("active");
    //   spShopIndex = $(this).index();
    //   if (spShopIndex == 0) {
    //     $(".sp-index1").show();
    //     $(".sp-index2").hide();
    //     sp_price1 = sp_price_list[0].price1;
    //     sp_price2 = sp_price_list[0].price2;
    //   } else {
    //     $(".sp-index1").hide();
    //     $(".sp-index2").show();
    //     sp_price1 = sp_price_list[1].price1;
    //     sp_price2 = sp_price_list[1].price2;
    //   }
    //   $("#sp_price1").html(calcTotal(sp_price1, 1));
    //   $("#sp_price2").html(calcTotal(sp_price2, 1));
    //   $("#calcNumber").val(1);
    // });

    // 点击放大按钮
    $(".sp-large,.p-img").click(function () {
      $(".sp-mask").css("display", "flex");
      let _img;
      if (spShopIndex == 0) {
        _img = $(".product-part .sp-index1 .p-img");
        $(".sp-mask .img-pop .sp-img")[0].src = _img[0].srcset;
        $(".sp-mask .img-pop").css("height", "1200px");
      } else {
        _img = $(".product-part .sp-index2 .p-img");
        $(".sp-mask  .img-pop  .sp-img")[0].src = _img[0].srcset;
        $(".sp-mask  .img-pop  .sp-img")[1].src = _img[1].srcset;
        $(".sp-mask .img-pop").css("height", "unset");
      }
      $(".sp-mask .img-pop").css("display", "flex");
      $(".sp-mask .size-pop").hide();
    });
    let colorList = ["Black", "White", "Khaki", "Grey", "Wine Red", "Blue"];
    let modelList = ["M", "L", "XL", "2XL", "3XL"];
    // 模拟select-option
    $(".sp-select").click(function () {
      $(this).siblings(".select-opt").toggle();
    });

    $(".select-opt li").click(function () {
      let spimg = $(".product-part .sp-index2 .p-img");
      let _index = $(this).index();
      let _color = $(this).attr("data-color");
      let _parent = $(this).parent().parent().siblings(".sp-select");
      if (_parent.attr("data-type") == "spColor1") {
        if (_index == 1) {
          _parent.html(
            `<span style="background: ${_color};border: 1px solid #989898;"></span>${colorList[_index]}`
          );
        } else {
          _parent.html(
            `<span style="background: ${_color};"></span>${colorList[_index]}`
          );
        }
        spimg[0].srcset = spImgList[_index];
      } else if (_parent.attr("data-type") == "spColor2") {
        _parent.html(
          `<span style="background: ${_color};"></span>${colorList[_index]}`
        );
        spimg[1].srcset = spImgList[_index];
      } else {
        _parent.text(modelList[_index]);
      }
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      $(".select-opt").hide();
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
    //   let spNum = $(".product-part #calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // $("#calcNumber").val(1);
    //   $("#cardNum").html(initNum);
      // handleAddToCart(initNum);

      // var img = $(".product-part .p-img");

      var cart =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer')
    var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        };
    if (cart) {
      data['sections'] = cart.getSectionsToRender().map(section => section.id)
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function (res) {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
              if (result.item_count > 0) {
                $('.sp-num').removeClass('sp-gray')
              } else {
                $('.sp-num').addClass('sp-gray')
              }
            });
        if (!cart) {
          window.location = window.routes.cart_url
          // that.closePop();
        } else {
          cart.renderContents(res)
          if (cart && cart.classList.contains('is-empty'))
            cart.classList.remove('is-empty')
        }
      },
      dataType: 'json',
    })

      
        // $.ajax({
        //   type: "POST",
        //   url: "/cart/add.js",
        //   data: data,
        //   success: function () {
        //     $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        //       $("#cardNum").html(result.item_count);
        //       if (result.item_count > 0) {
        //         $('.sp-num').removeClass('sp-gray')
        //       } else {
        //         $('.sp-num').addClass('sp-gray')
        //       }
        //     });
        //   },
        //   dataType: "json",
        // });

    //   var img;
    //   if (spShopIndex == 0) {
    //     img = $(".product-part .sp-index1 .p-img");
    //   } else {
    //     img = $(".product-part .sp-index2 .p-img");
    //   }

    //   var flyer = img[0].cloneNode(true);
    //   flyer.classList.add("sp_clone");

    //   $(".product-part").append(flyer);
    //   $(".sp_clone").css({
    //     width: img[0].width,
    //     height: img[0].height,
    //     background: "#F1F1F3",
    //     position: "fixed",
    //     top: img[0].offsetTop,
    //     left: img.offset().left,
    //     "z-index": "99",
    //   });

    //   let finish = $(".sp-cart");
    //   $(".sp_clone").animate(
    //     {
    //       top: finish[0].offsetTop + $(".time-part").height(),
    //       left: finish[0].offsetLeft + finish.width() / 2,
    //       width: 50, // 结束时的大小，根据需要调整
    //       height: 50, // 结束时的大小，根据需要调整
    //       opacity: 0.4,
    //     },
    //     500,
    //     "linear",
    //     function () {
    //       $(this).animate(
    //         {
    //           width: 0,
    //           height: 0,
    //           opacity: 0,
    //         },
    //         0,
    //         function () {
    //           $(this).detach();
    //         }
    //       );
    //     }
    //   );
      // 另一个
      if (spShopIndex == 1) {
        var img2;

        img2 = $(".product-part .sp-index2 .p-img2");
        var flyer2 = img2[0].cloneNode(true);
        flyer2.classList.add("sp_clone2");

        $(".product-part").append(flyer2);
        $(".sp_clone2").css({
          width: img2[0].width,
          height: img2[0].height,
          position: "fixed",
          background: "#FAF4EE",
          top: img2[0].offsetTop,
          left: img2.offset().left,
          "z-index": "99",
        });

        $(".sp_clone2").animate(
          {
            top: finish[0].offsetTop + $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // // 环形旋转木马
  // // var slideW = 360; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  // // var radius = (slideW * 0.5) / Math.sin(Math.PI / 16); //半径。圆心并不是视点中心，视点在1200px
  // var slideW = 360; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  // var radius = (slideW * 0.5) / Math.sin(Math.PI / 16); //半径。圆心并不是视点中心，视点在1200px

  // carouselSwiper = new Swiper("#carousel .swiper", {
  //   watchSlidesProgress: true,
  //   slidesPerView: "auto",
  //   centeredSlides: false,
  //   loop: true,
  //   loopedSlides: 3,
  //   grabCursor: true,
  //   autoplay: {
  //     delay: 0,
  //     stopOnLastSlide: false,
  //     disableOnInteraction: false,
  //   },
  //   freeMode: true,
  //   speed: 5000, //匀速时间
  //   on: {
  //     progress: function (swiper, progress) {
  //       for (i = 0; i < this.slides.length; i++) {
  //         var slide = this.slides.eq(i);
  //         var slideProgress = this.slides[i].progress;
  //         const translateX =
  //           (slideProgress + 1.5) *
  //             (slideW / 3 -
  //               (Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) *
  //                 slideW *
  //                 1.1) /
  //                 3) +
  //           "px"; //调整图片间距，根据图片宽度改变数值实现自适应
  //         const rotateY = (slideProgress + 1.5) * 22.5; //图片角度
  //         const translateZ =
  //           radius -
  //           Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) * radius -
  //           150 +
  //           "px"; //调整图片远近，刚好4个在画框内
  //         slide.transform(
  //           "translateX(" +
  //             translateX +
  //             ") translateZ(" +
  //             translateZ +
  //             ") rotateY(" +
  //             rotateY +
  //             "deg)"
  //         );
  //       }
  //     },
  //     setTransition: function (swiper, transition) {
  //       for (var i = 0; i < this.slides.length; i++) {
  //         var slide = this.slides.eq(i);
  //         slide.transition(transition);
  //       }
  //     },
  //   },
  // });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
